import { Empty } from 'antd';
import React__default from 'react';
import DefaultEmptyImg from '../pebble-icons/DefaultEmpty.js';

var _excluded = ["image"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var defaultEmptyImg = /*#__PURE__*/React__default.createElement(DefaultEmptyImg, null);
var EmptyWithImg = function EmptyWithImg(props) {
  var _props$image = props.image,
    image = _props$image === void 0 ? defaultEmptyImg : _props$image,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/React__default.createElement(Empty, _extends({}, rest, {
    image: image
  }));
};
var PEmpty = EmptyWithImg;

export { PEmpty as default };
